import React, { useState, useEffect } from "react";
import _ from 'lodash'
import "./Main.css"

function Main(props) {
  let arr = props.packageInfo.config;
  let override = props.packageInfo.config.override || {}
  let realDevice = props.packageInfo.modules.realDevice
  const [choosenAnswer, setChoosenAnswer] = useState(
    props.packageInfo.config.AnswerOptionDisplayType === "image" && props.packageInfo.config.image?.allowMultipleSelection ? 
      ((arr.dataPath && Array.isArray(_.get(realDevice, "variables." + arr.dataPath, null))) ? _.get(realDevice, "variables." + arr.dataPath) : []) : 
      ((arr.dataPath && typeof _.get(realDevice, "variables." + arr.dataPath, null)) ? _.get(realDevice, "variables." + arr.dataPath) : '')
  )
  const modules = props.packageInfo.modules
  const locale = modules?.locale
  let message = props.packageInfo.message || {}
  let buttons = message.quantities.buttons
  let ioc = modules?.ioc
  
  let parent = modules?.parent || {}
  let el = props.packageInfo.el
  
  let cancelActions = arr.listOfCancelActions?.split("\n")
  const press = ioc.injectWithModules(["3r/message-api/helpers/press"], function(press, buttonIndex,buttonValue) {
    let { packageInfo } = props;
    let button = buttons[buttonIndex]
    
    if (cancelActions.includes(buttonValue)) {
        packageInfo.modules.device.triggerOutcome("Cancel")
        if (!button.close) {
            packageInfo.modules.device.triggerOutcome(button.value)
        }
        return press(
            null,
            function () {
                    return packageInfo.modules.device.triggerOutcome(button.value, true)
            },
            message,
            button
        )
    } else {
        return press(
            null,
            function () {
                return packageInfo.modules.device.triggerOutcome(button.value, true)
            },
            message,
            button
        )   
    }
  })
  
  useEffect(()=>{
    if(parent?.container) {
      el.threeRadicalForm = { 
          status : async function () {
              return buildPackageStatus.apply(this)
          }
      }
      
      el.threeRadicalForm.status = el.threeRadicalForm.status.bind(this)
    }
  }, [])
  
  const handleClick = async(op) => {
    let { packageInfo } = props;
    
    if(!parent.form) {
      
      if (arr.dataPath) {
        await packageInfo.modules.realDevice.canUpdateData();
        let variables = await packageInfo.modules.realDevice.variables || {};
        console.log("Var Before: ", JSON.stringify(variables))
        _.set(variables, arr.dataPath, op.outcome);
        _.set(variables, arr.dataPath + "_Array", [ op.outcome ]);
        _.set(variables, ["quizQuestionMultipleChoice", "singleSubmissions", arr.dataPath], Date.now());
        packageInfo.modules.realDevice.variables = variables
      }
      
      const triggeredOutcomeResult = await packageInfo.modules.device.triggerOutcome(
        op.outcome,
        true
      );
      
      if (arr.unlockCode) {
        await packageInfo.modules.device.unlock(arr.unlockCode, op.outcome) 
      }
      
      if (packageInfo.config.showCorrectIncorrectMessage) {
        if (op.isCorrect) {
          modules.message({title : "Correct!", message : "Correct!"})
        } else {
          modules.message({title : "Incorrect!", message : "Incorrect!"})
        }
      }
    } else {
      setChoosenAnswer(op.outcome)
      
      let eventDetails = buildPackageStatus.apply(this, [op.outcome])
      
      console.log("- Sending state to parent form: ", JSON.stringify(eventDetails))
      el.dispatchEvent(new CustomEvent("threeRadical.form.state", { detail: eventDetails }))
    }
  };
  
  const handleClickMultiSelect = async(answers) => {
    let { packageInfo } = props;
    
    if(!parent.form) {
      if (arr.dataPath) {
        await packageInfo.modules.realDevice.canUpdateData();
        let variables = await packageInfo.modules.realDevice.variables || {};
        console.log("Var Before: ", JSON.stringify(variables))
        _.set(variables, arr.dataPath, choosenAnswer);
        _.set(variables, ["quizQuestionMultipleChoice", "singleSubmissions", arr.dataPath], Date.now());
        packageInfo.modules.realDevice.variables = variables
      }
      
      let isCorrect = true
      for(let i = 0; i < answers.length; i++) {
        let op = answers[i]
        const triggeredOutcomeResult = await packageInfo.modules.device.triggerOutcome(
          op.outcome,
          i === (answers.length - 1)
        );
        
        if (arr.unlockCode) {
          await packageInfo.modules.device.unlock(arr.unlockCode, op.outcome) 
        }
    
        if (packageInfo.config.showCorrectIncorrectMessage) {
          if (!op.isCorrect) {
            isCorrect = false
          }
        }
      }
      
      if(packageInfo.config.showCorrectIncorrectMessage) {
        if(isCorrect) {
          modules.message({title : "Correct!", message : "Correct!"})
        } else {
          modules.message({title : "Incorrect!", message : "Incorrect!"})
        }
      }
    } else {
      let eventDetails = buildPackageStatus.apply(this, null)
      
      console.log("- Sending state to parent form: ", JSON.stringify(eventDetails))
      el.dispatchEvent(new CustomEvent("threeRadical.form.state", { detail: eventDetails }))
    }
  };
  
  const handleAnswerSelect = (event) => {
    setChoosenAnswer(event.target.value)
    
    if(parent?.form) {
      let eventDetails = buildPackageStatus.apply(this, [event.target.value])
      
      console.log("- Sending state to parent form: ", JSON.stringify(eventDetails))
      el.dispatchEvent(new CustomEvent("threeRadical.form.state", { detail: eventDetails }))
    }
  }
  
  const handleMultipleAnswerSelect = (op) => {
    let currentAnswer = _.clone(choosenAnswer)
    if(currentAnswer.indexOf(op.outcome) !== -1) {
      currentAnswer = currentAnswer.filter(a => {
        return a !== op.outcome
      })
    } else {
      _.uniq(currentAnswer.push(op.outcome))
    }
    
    if(parent?.form) {
      let eventDetails = buildPackageStatus(currentAnswer)
      
      console.log("- Sending state to parent form: ", JSON.stringify(eventDetails))
      el.dispatchEvent(new CustomEvent("threeRadical.form.state", { detail: eventDetails }))
    }
    setChoosenAnswer(currentAnswer)
  }
  
  const buildPackageStatus = (outcome) => {
    if(props.packageInfo.config.AnswerOptionDisplayType === "image" && props.packageInfo.config.image?.allowMultipleSelection) {
      return {
        canSubmit: !!((Array.isArray(outcome) && outcome.length) || (!Array.isArray(outcome) && choosenAnswer.length)),
        value: outcome,
        validation: !!((Array.isArray(outcome) && outcome.length) || (!Array.isArray(outcome) && choosenAnswer.length)) ? [] : ["Please pick one or more of the available answers"]
      }
    } else {
      return {
        canSubmit: !!(outcome || choosenAnswer), 
        value: outcome,
        validation: !!((outcome || choosenAnswer) ? [] : ["Please pick one of the available answers"])
      }
    }
  }
  
  const handleSubmit = (button) => {
    let { packageInfo } = props;
    if(props.packageInfo.config.AnswerOptionDisplayType === "image" && props.packageInfo.config.image?.allowMultipleSelection) {
      let answerChoosen = arr.Options.filter(function (e) {
          return choosenAnswer.indexOf(e.outcome) !== -1;
      })
      
      if(choosenAnswer.length) {
        handleClickMultiSelect(answerChoosen)
        if(button) {
          return press(button.index,button.value)
        } else {
          return packageInfo.modules.device.triggerOutcome("Valid")
        }
      } else {
        modules.message({title : "Error", message : "Select one or more answers before submitting."})
        return packageInfo.modules.device.triggerOutcome("Invalid")
      }
    } else {
      let answerChoosen = arr.Options.filter(function (e) {
          return e.outcome == choosenAnswer;
      })
      
      if(choosenAnswer) {
        handleClick(answerChoosen[answerChoosen.length - 1])
        if(button) {
          return press(button.index,button.value)
        } else {
          return packageInfo.modules.device.triggerOutcome("Valid")
        }
      } else {
        modules.message({title : "Error", message : "Select answer before submitting."})
        return packageInfo.modules.device.triggerOutcome("Invalid")
      }
    }
  }
  
  const handleCancel = (button) => {
    let { packageInfo } = props;
    if(button) {
      return press(button.index,button.value)
    } else {
      return packageInfo.modules.device.triggerOutcome("Cancel")
    }
  }
  
  const AnswerOptionDisplay = () => {
    if(arr.AnswerOptionDisplayType == 'button'){
      return <div className="wf-tactic-quiz-mcq-options wf-tactic-quiz-options wf-tactic-options wf-options">
        {
          (arr.Options.map((op, i) => (
            <button 
              id={"questionMultipleButton-" + (op.outcome || "").replace(/\s+/g,"")} 
              className={
                "wf-tactic-quiz-mcq-option-" + i + " wf-tactic-quiz-mcq-option wf-tactic-quiz-option wf-tactic-option wf-option btn btn-" + 
                (choosenAnswer === op.outcome ? "primary": "outline-primary") + " m-2"
              }
              key={op.outcome + i} onClick={() => handleClick(op)}>
              {locale.copy(op.Answer)}
            </button>
          )))
        }
      </div>
    } else if(arr.AnswerOptionDisplayType == 'gridButton'){
      return <div className={ "wf-tactic-quiz-options" }>
          <div class = "wf-tactic-multiple-choice-grid-container">
            {
              
              (arr.Options.map((op, i) => (
               <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-6">
                
                  <button type="button" class="btn btn-light wf-tactic-grid-small-btn" id={"questionMultipleButton-" + (op.outcome || "").replace(/\s+/g,"")} key={op.outcome + i} onClick={() => handleClick(op)}>
                  {locale.copy(op.Answer)}</button>
                </div>
              </div>
              )))
            }
            
          </div>
      </div>
    } else if(arr.AnswerOptionDisplayType == "select") {
      let dropOptions = arr.Options.map((op, i) => (
        <option className={"wf-tactic-quiz-mcq-option-" + i + " wf-tactic-quiz-mcq-option wf-tactic-quiz-option wf-tactic-option wf-option"} key={op.outcome + i} value={op.outcome}>{locale.copy(op.Answer)}</option>
      ))
      return(
        <div className="wf-tactic-quiz-mcq-selectOptionsContainer wf-tactic-quiz-selectOptionsContainer wf-tactic-selectOptionsContainer wf-selectOptionsContainer container-fluid">
          <select value={choosenAnswer} onChange={handleAnswerSelect} className="wf-tactic-quiz-mcq-options wf-tactic-quiz-options wf-tactic-options wf-options form-control mb-3">
              <option className="wf-tactic-quiz-mcq-optionPlaceholder wf-tactic-quiz-optionPlaceholder wf-tactic-optionPlaceholder wf-optionPlaceholder" value="">Choose Answer</option>
              {dropOptions}
          </select>
          { !parent.form && 
            <button className="wf-tactic-quiz-mcq-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit btn btn-primary" onClick={()=>handleSubmit()}>
              Submit
            </button>
          }
        </div>
      )
    } else if (arr.AnswerOptionDisplayType == "image") {
      return <div className="wf-tactic-quiz-mcq-imageOptionsContainer wf-tactic-quiz-imageOptionsContainer wf-tactic-imageOptionsContainer wf-imageOptionsContainer row mt-4">
        <div className="wf-tactic-quiz-mcq-options wf-tactic-quiz-options wf-tactic-options wf-options col-md-12 col-md-offset-3">
          {
            arr.Options.map((op, i) => (
              <div 
                key={op.outcome + i} 
                className={"wf-tactic-quiz-mcq-option-" + i + " wf-tactic-quiz-mcq-option wf-tactic-quiz-option wf-tactic-option wf-option col-md-12 mb-3"} 
                onClick={() => {
                  props.packageInfo.config.image?.enableActionButtons ? 
                    (props.packageInfo.config.image?.allowMultipleSelection ? handleMultipleAnswerSelect(op) : handleAnswerSelect({ target: { value: op.outcome }})) :
                    handleClick(op)
                }}
              >
                <div className={
                    "card mw-100 w-100 " + 
                    (
                      Array.isArray(choosenAnswer) && choosenAnswer.indexOf(op.outcome) !== -1 ?
                        "wf-selected" : 
                        (choosenAnswer === op.outcome ? "wf-selected": "wf-notSelected")
                    )
                  } 
                  style={{cursor: "pointer"}}
                >
                 <div className={"wf-tactic-quiz-mcq-optionBox-" + i + " wf-tactic-quiz-mcq-optionBox wf-tactic-quiz-optionBox wf-tactic-optionBox wf-optionBox card-body text-center"}>
                    <img className={"wf-tactic-quiz-mcq-optionImage-" + i + " wf-tactic-quiz-mcq-optionImage wf-tactic-quiz-optionImage wf-tactic-optionImage wf-optionImage card-body text-center"} src={locale.copy(op?.Image)} alt={locale.copy(op.Answer)} style={{height: "120px",objectFit: "contain"}}/>
                    <p className={"wf-tactic-quiz-mcq-optionTitle-" + i + " wf-tactic-quiz-mcq-optionTitle wf-tactic-quiz-optionTitle wf-tactic-optionTitle wf-optionTitle mt-3 mb-0"}>{locale.copy(op.Answer)}</p>  
                 </div>
                </div>
              </div>
            ))
          }
        </div>
        { !parent.form && props.packageInfo.config.image?.enableActionButtons && 
          <div className={"wf-tactic-quiz-mcq-actions wf-tactic-quiz-actions wf-tactic-actions wf-actions col-md-12 "}>
            { !buttons.length && <>
                { locale.copy(props.packageInfo.config.image?.defaultCancel) && 
                  <button className="wf-tactic-quiz-mcq-cancel wf-tactic-quiz-cancel wf-tactic-cancel wf-cancel btn btn-primary" onClick={()=>handleCancel()}>
                    {locale.copy(props.packageInfo.config.image?.defaultCancel)}
                  </button>
                }
                {
                  <button 
                    disabled={!(choosenAnswer.length)}
                    className="wf-tactic-quiz-mcq-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit btn btn-primary" 
                    onClick={()=>handleSubmit()}
                  >
                    {locale.copy(props.packageInfo.config.image?.defaultSubmit)}
                  </button>
                }
              </>
            }
            {
              !!buttons.length && buttons.map((button, i) => 
                button.type === 'hyperlink' ? 
                    <a href={button.hyperlink.url} rel="" target={button.hyperlink.target}>
                        {
                            cancelActions.includes(button.value) ?
                                <button type="button" className={"wf-tactic-quiz-mcq-cancel-" + i + " wf-tactic-quiz-mcq-cancel wf-tactic-quiz-cancel wf-tactic-cancel wf-cancel btn btn-primary"} style={{margin: "10px"}} onClick={()=>handleCancel(button)} key={button.value}>
                                    {embedContent(button.caption)}
                                </button>
                            :
                                <button type="button" className={"wf-tactic-quiz-mcq-submit-" + i + " wf-tactic-quiz-mcq-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit btn btn-primary"} style={{margin: "10px"}} onClick={()=>handleSubmit(button)} key={button.value}>
                                    {embedContent(button.caption)}
                                </button>
                        }
                      
                    </a>
                : 
                    cancelActions.includes(button.value) ?
                        <button type="button" className={"wf-tactic-quiz-mcq-cancel-" + i + " wf-tactic-quiz-mcq-cancel wf-tactic-quiz-cancel wf-tactic-cancel wf-cancel btn btn-primary"} style={{margin: "5px"}} onClick={()=>handleCancel(button)} key={button.value}>{embedContent(button.caption)}</button>
                    :
                        <button type="button" className={"wf-tactic-quiz-mcq-submit-" + i + " wf-tactic-quiz-mcq-submit wf-tactic-quiz-submit wf-tactic-submit wf-submit btn btn-primary"} style={{margin: "5px"}} onClick={()=>handleSubmit(button)} key={button.value}>{embedContent(button.caption)}</button>
            )}
          </div>
        }
      </div>
    }
  }
  
  let embedContent = ioc.injectWithModules(["3r/message-api/content/embedMessageContent"], function(embedMessageContent, text){
    return embedMessageContent(message, {}, text)     
  })
  
  let title = locale.copy(override?.title) || embedContent(message.title)
  let titleElement = override.titleDisplay
  let markedUp = locale.copy(override?.message) || ioc.run("3r/message-api/content/embedMessageContent", message.markedUp)
  let footer = locale.copy(override?.footer)
  let image = locale.copy(override?.image) || ( (message.offerImage && message.offerImage != "undefined.jpg") ? message.offerImage : "" )
  let imagePlacement = locale.copy(override?.imagePlacement)

  return (
    <div id={"questionMultiple" + message.systemId} className="wf-tactic-quiz-mcq wf-tactic-quiz wf-tactic container mt-4 questionMultipleOptions">
      { (!parent.form && titleElement && imagePlacement == 'normal') ? React.createElement(titleElement, { className: imagePlacement == 'left'?'wf-tactic-quiz-title-left':imagePlacement == 'right'?'wf-tactic-quiz-title-right' :'wf-tactic-quiz-mcq-title wf-tactic-quiz-title wf-tactic-title wf-title' }, title) : "" }
      { (!parent.form && image && imagePlacement == 'normal')
          ?  <div className = "wf-tactic-quiz-mcq-offerImageBox wf-tactic-quiz-offerImageBox wf-tactic-offerImageBox wf-offerImageBox">
                  <img className="wf-tactic-quiz-mcq-offerImage wf-tactic-quiz-offerImage wf-tactic-offerImage wf-offerImage" style={{width:"100%"}} src={image} alt={title}/>
              </div>
          : ""
      }
      { (!parent.form && image && imagePlacement == 'left')
          ? <div class="container">
              <div class="row">
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <img className="wf-tactic-quiz-mcq-offerImage" style={{width:"100%"}} src={image} alt={title}/>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12 wf-tactic-quiz-title-left">
                  <div class="row">
                    { (!parent.form && titleElement) ? React.createElement(titleElement, { className: 'wf-tactic-quiz-mcq-title' }, title) : "" }
                  </div>
                  <div class="row">
                    { (!parent.form && markedUp)
                        ?   <p className = {"wf-tactic-quiz-mcq-message"} dangerouslySetInnerHTML={{__html: markedUp}}></p> 
                        : ""
                    }
                  </div>
                  <div class="row">
                    <AnswerOptionDisplay />
                  </div>
                </div>
                
               
              </div>
            </div>
          : ""
      }
      { (!parent.form && image && imagePlacement == 'right')
          ? <div class="container">
              <div class="row">
                  <div class="col-md-6 col-sm-6 col-xs-12 wf-tactic-quiz-title-right">
                    <div class="row">
                      { (!parent.form && titleElement) ? React.createElement(titleElement, { className: 'wf-tactic-quiz-mcq-title' }, title) : "" }
                    </div>
                    <div class="row">
                      { (!parent.form && markedUp)
                          ?   <p className = {"wf-tactic-quiz-mcq-message"} dangerouslySetInnerHTML={{__html: markedUp}}></p> 
                          : ""
                      }
                    </div>
                    <div class="row">
                      <AnswerOptionDisplay />
                    </div>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-12">
                  <img className="wf-tactic-quiz-mcq-offerImage" style={{width:"100%"}} src={image} alt={title}/>
                </div>
              
              </div>
            </div>
          : ""
      }
     
      { (!parent.form && markedUp && imagePlacement == 'normal')
          ?   <p className = {imagePlacement == 'left'?"wf-tactic-quiz-mcq-message-left":imagePlacement == 'right'?"wf-tactic-quiz-mcq-message-right":"wf-tactic-quiz-mcq-message wf-tactic-quiz-message wf-tactic-message wf-message"} dangerouslySetInnerHTML={{__html: markedUp}}></p> 
          : ""
      }
      { (parent.form || imagePlacement == 'normal')
       ?  <AnswerOptionDisplay /> : ""
      }
      { (!parent.form && footer)
          ?   <p className = "wf-tactic-quiz-mcq-footer wf-tactic-quiz-footer wf-tactic-footer wf-footer" dangerouslySetInnerHTML={{__html: footer}}></p> 
          : ""
      }
    </div>
  );
}

export default Main;
